export const EVENT_BUS_TYPE = {
  BATCH_PROCESS_RELOAD_SUBGRID: "BATCH_PROCESS::RELOAD_SUBGRID",
  BATCH_REVIEW_RELOAD: "BATCH_REVIEW:RELOAD"
};
